import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';

import { Logo } from '../../../logo/Logo';
import type { AppData } from '../../../../types/app_data';

import { JerryFooter } from './JerryFooter';

export interface FooterProps {
  className?: string;
  noShowFooterLogo?: boolean;
  footerLogoGrey?: boolean;
  appendFooter?: JSX.Element;
  footer?: JSX.Element;
  appData?: AppData;
}

/**
 * Top nav bar with logo and menu.
 */
const UnstyledFooter: FunctionComponent<FooterProps> = ({
  className,
  noShowFooterLogo,
  footerLogoGrey,
  appendFooter,
  footer,
  appData,
}) => {
  return (
    <Box id="footer" borderTop={1} borderColor="#DBDDDE" py={2} className={className}>
      <Container maxWidth="md" className="container">
        {!noShowFooterLogo && (
          <Box pt={1}>
            <Logo markOnly color={footerLogoGrey ? 'grey' : undefined} />
          </Box>
        )}
        <Box pl={2} className="footerText">
          {footer ? footer : <JerryFooter />}
        </Box>
      </Container>
      {appendFooter}
    </Box>
  );
};

export const Footer = styled(UnstyledFooter)`
  .container {
    display: flex;
    justify-content: center;
  }
  .footerText {
    font-size: 12px;
    color: #6b7a86;
  }
`;
